import { useLazyQuery } from '@apollo/client/react';
import { useMemo } from 'react';

import { GetYakumaruOrganizationSettingOnOrganizationDocument } from '~/graphql/generated/graphql';
import { getMe } from '~/graphql/utility';

export const useFetchYakumaruOrganizationSetting = () => {
  const [getYakumaruOrganizationSetting, { called, data, loading }] = useLazyQuery(
    GetYakumaruOrganizationSettingOnOrganizationDocument,
    {
      fetchPolicy: 'network-only',
    },
  );

  const me = data ? getMe(data) : null;
  const organization = me?.organization;
  const organizationId = organization?.id ?? null;
  const pharmacyCode = organization?.pharmacyCode ?? null;
  const yakumaruOrganizationSetting = useMemo(
    () => organization?.yakumaruOrganizationSetting ?? null,
    [organization],
  );

  return {
    getYakumaruOrganizationSetting,
    loading: !called || loading,
    organizationId,
    pharmacyCode,
    yakumaruOrganizationSetting,
  };
};
